import { sortSimpleChartData } from 'containers/Transactions/components/TransactionGraphRegister/utils';

export const MAX_PIE_DISPLAY_ITEMS = 11;

export type PieDisplayItem<T> =
  | T
  | {
      category: 'Everything else';
      total: number;
      categoryId: 'everything-else';
      isEverythingElse: true;
      remainingItems: T[];
    };

type PieDisplaySource = { category: string; total: number };

// The report pie and Sideways Bar share this final, visual projection of their common report
// data: value ordering plus the folded tail bucket. Keeping it here prevents small differences
// (such as summing absolute totals in only one chart) from making the two views diverge.
export const buildPieDisplayData = <T extends PieDisplaySource>(
  data: T[],
  showAllItems: boolean,
  maxItems = MAX_PIE_DISPLAY_ITEMS,
): PieDisplayItem<T>[] => {
  const sortedData = [...data].sort(sortSimpleChartData);
  if (showAllItems || sortedData.length <= maxItems) return sortedData;

  const topItems = sortedData.slice(0, maxItems);
  const remainingItems = sortedData.slice(maxItems);
  return [
    ...topItems,
    {
      category: 'Everything else',
      total: remainingItems.reduce((sum, item) => sum + item.total, 0),
      categoryId: 'everything-else',
      isEverythingElse: true,
      remainingItems,
    },
  ];
};
